<template>
  <v-app>
    <div
      v-if="$store.state.loggedin"
    >
      <v-navigation-drawer
        app
        class="elevation-1"
        fixed
        v-model="showDrawer"
      >
        <template v-slot:prepend>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                Zebrabox
              </v-list-item-title>
              <v-list-item-subtitle v-if="false">
                CRM
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <div data-v-e83acb18="" class="v-list v-sheet theme--light v-list--dense v-list--nav">
          <div><!---->
            <v-list>
              <v-list-item v-for="(item, i) in navitems" v-bind:key="i"
                            :to="{ name: item.route }">
                <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
                <v-list-item-title>
                  {{item.name}}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </v-navigation-drawer>
    </div>
    <v-app-bar
      app
      color="white"
      v-if="$store.state.loggedin"
    >
      <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-menu
        left
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <header v-if="false" data-v-e83acb18="" class="v-sheet theme--light v-toolbar v-app-bar v-app-bar--fixed" data-booted="true" style="height: 64px; margin-top: 0px; transform: translateY(0px); left: 256px; right: 0px;"><div class="v-toolbar__content" style="height: 64px;"><div data-v-e83acb18="" class="flex-grow-1 d-flex v-card v-card--flat v-sheet theme--light pa-0 ma-0"><div data-v-e83acb18="" class="d-flex flex-grow-1 align-center"><div data-v-e83acb18="" class="d-flex flex-grow-1 align-center"><button data-v-e83acb18="" type="button" class="v-app-bar__nav-icon v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content"><i data-v-e83acb18="" aria-hidden="true" class="v-icon notranslate mdi mdi-menu theme--light"></i></span></button><div data-v-e83acb18="" class="spacer d-none d-lg-block"></div><div data-v-e83acb18="" class="v-input mx-1 hidden-xs-only v-input--hide-details v-input--dense theme--light v-text-field v-text-field--single-line v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-text-field--placeholder v-text-field--rounded"><div class="v-input__control"><div class="v-input__slot"><div class="v-input__prepend-inner"><div class="v-input__icon v-input__icon--prepend-inner"><i aria-hidden="true" class="v-icon notranslate mdi mdi-magnify theme--light"></i></div></div><div class="v-text-field__slot"><input id="input-221" placeholder="Search (press &quot;ctrl + /&quot; to focus)" type="text"></div></div></div></div><div data-v-e83acb18="" class="spacer d-block d-sm-none"></div><button data-v-e83acb18="" type="button" class="d-block d-sm-none v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content"><i data-v-e83acb18="" aria-hidden="true" class="v-icon notranslate mdi mdi-magnify theme--light"></i></span></button><div data-v-e83acb18="" class="v-menu"><!----></div><button type="button" class="v-btn v-btn--text theme--light v-size--default"><span class="v-btn__content"><span data-v-7bb95338="" class="flag-icon flag-icon-us"></span><span class="ml-1">English</span><!----></span></button><div data-v-e83acb18="" class="hidden-xs-only mx-1"><button type="button" class="v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content">$ USD</span></button><div data-v-e83acb18="" class="v-menu"><!----></div></div><div data-v-c2ffbc8a="" data-v-e83acb18="" class="v-menu"><!----></div><button data-v-c2ffbc8a="" type="button" class="v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content"><i data-v-c2ffbc8a="" aria-hidden="true" class="v-icon notranslate mdi mdi-view-grid-outline theme--light"></i></span></button><div data-v-e83acb18="" class="mr-1"><span class="v-badge v-badge--bordered theme--light"><button type="button" class="v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-bell-outline theme--light"></i></span></button><span class="v-badge__wrapper"><span aria-atomic="true" aria-label="Badge" aria-live="polite" role="status" class="v-badge__badge primary" style="inset: auto auto calc(100% - 22px) calc(100% - 22px);">6</span></span></span><div data-v-e83acb18="" class="v-menu"><!----></div></div><div data-v-e83acb18="" class="v-menu"><!----></div><button type="button" class="elevation-2 v-btn v-btn--icon v-btn--round theme--light v-size--default"><span class="v-btn__content"><span class="v-badge v-badge--bordered v-badge--dot theme--light"><div class="v-avatar" style="height: 40px; min-width: 40px; width: 40px;"><div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 106.061%;"></div><div class="v-image__image v-image__image--cover" style="background-image: url(&quot;https://lux-admin-pro.indielayer.com/images/avatars/avatar1.svg&quot;); background-position: center center;"></div><div class="v-responsive__content" style="width: 264px;"></div></div></div><span class="v-badge__wrapper"><span aria-atomic="true" aria-label="Badge" aria-live="polite" role="status" class="v-badge__badge success" style="inset: auto auto calc(100% - 10px) calc(100% - 10px);"></span></span></span></span></button></div></div></div></div></header>

    <v-main v-if="$store.state.loggedin">
      <router-view/>
    </v-main>
    <Spinner v-if="!$store.state.gotstate" />
    <Login  v-if="$store.state.gotstate && !$store.state.loggedin" />
  </v-app>
</template>

<script>

import BackendService from './service/BackendService';
import Spinner from './components/Spinner.vue';
import Login from './components/Login.vue';

export default {
  name: 'App',
  components: {
    Login,
    Spinner,
  },

  created() {
    if (document.ve_heartbeat !== undefined) {
      window.clearInterval(document.ve_heartbeat);
    }
    document.ve_heartbeat = window.setInterval(() => {
      BackendService.heartbeat().then((data) => {
        if (data.data.loggedin !== undefined) {
          this.$store.commit('updateLoginState', data.data.loggedin);
        }
      });
    }, 30000);
    BackendService.getState().then((data) => {
      this.$store.commit('upadteState', data.data);
    });
  },

  data: () => ({
    showDrawer: true,
    navitems: [
      {
        name: 'Requests',
        icon: 'fal fa-handshake',
        route: 'requests',
      },
      {
        name: 'Categories',
        icon: 'fal fa-list',
        route: 'categories',
      },
      {
        name: 'Locations',
        icon: 'fal fa-map-marker-alt',
        route: 'locations',
      },
      {
        name: 'Durations',
        icon: 'fal fa-clock',
        route: 'durations',
      },
      {
        name: 'Sizes',
        icon: 'fal fa-th-large',
        route: 'sizes',
      },
      {
        name: 'Referrer Types',
        icon: 'fal fa-comment',
        route: 'referrer_types',
      },
      {
        name: 'Storage Reasons',
        icon: 'fal fa-question',
        route: 'storage_reasons',
      },
      {
        name: 'Translations',
        icon: 'fal fa-language',
        route: 'translations',
      },
      {
        name: 'Vouchers',
        icon: 'fal fa-ticket',
        route: 'vouchers',
      },
      {
        name: 'Insurance',
        icon: 'fal fa-shield-alt',
        route: 'insurance',
      },
      {
        name: 'Countries',
        icon: 'fal fa-globe-europe',
        route: 'countries',
      },
      {
        name: 'Storage Purpose',
        icon: 'fal fa-archive',
        route: 'storage_purpose',
      },
      {
        name: 'Matrix',
        icon: 'fal fa-th',
        route: 'matrix',
      },
      {
        name: 'Payment Accounts',
        icon: 'fal fa-money-bill',
        route: 'payment',
      },
      {
        name: 'Contryspecific Settings',
        icon: 'fal fa-flag',
        route: 'countrysettings',
      },
    ],
  }),
  methods: {
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    logout() {
      BackendService.logout().then((data) => {
        this.$store.commit('upadteState', data.data);
      });
    },
  },
};
</script>

<style lang="scss">
  @font-face {
    font-family: "KievitPro-Bold";
    src: url('assets/fonts/KievitPro-Bold.woff') format("woff");
  }
  @font-face {
    font-family: "KievitPro-Book";
    font-weight: 200;
    src: url("assets/fonts/KievitPro-Book.woff") format("woff");
  }
  @font-face {
    font-family: "KievitPro-Medium";
    src: url("assets/fonts/KievitPro-Medium.woff") format("woff");
  }

 .v-application {
   //   font-family: $body-font-family, sans-serif !important;
   .title, .v-card__title {
     font-family: KievitPro-Bold, sans-serif !important;
   }
 }

  .theme--light {
    &.v-application {
      background-color: #f2f5f8 !important;
    }

    .v-btn.v-btn--has-bg {
//      background-color: #FFDD00;
    }
  }

  .v-data-table__wrapper {
    .fa-trash {
      margin-left: 8px !important;
    }
  }
</style>
